import { createAction } from '@reduxjs/toolkit';
import { User } from '../../reducers/@types/user';

export const setUser = createAction<User>('@USER/SET_USER');
export const removeUser = createAction('@Account/REMOVE_USER');

export type UserActionTypes = typeof setUser | typeof removeUser;
